import IndexOrPageReturnLink from 'card-preview-highlight-lib/crm_ui/profile/common/components/IndexOrPageReturnLink';
//@ts-expect-error JSFile
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { COMPANY, CONTACT, DEAL, TICKET } from 'customer-data-objects/constants/ObjectTypes';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import RecordsErrorBoundary from '../../../../../errors/RecordsErrorBoundary';
import MiniCompanyHighlight from './MiniCompanyHighlight';
import MiniContactHighlight from './MiniContactHighlight';
import MiniCrmObjectHighlight from './MiniCrmObjectHighlight';
import MiniDealHighlight from './MiniDealHighlight';
import MiniTicketHighlight from './MiniTicketHighlight';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  state: PropTypes.oneOf(['Hidden', 'Visible', 'Hiding']),
  objectType: AnyCrmObjectTypePropType.isRequired,
  subjectId: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired
};

// @bend-expect trellis-tokenized
const MiniProfileHighlightWrapper = styled.div.withConfig({
  displayName: "MiniProfileHighlightContainer__MiniProfileHighlightWrapper",
  componentId: "sc-7u3qo3-0"
})(["position:fixed;width:", ";opacity:", ";transition:opacity 200ms cubic-bezier(0.42,0,0.58,1);pointer-events:", ";z-index:2;background-color:", ";overflow:hidden;height:72px;border-bottom:", ";"], ({
  width
}) => `${width}px`, ({
  state
}) => state === 'Hidden' ? 0 : 1, ({
  state
}) => state === 'Hidden' ? 'none' : 'auto', ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`);
function MiniProfileHighlightContainer({
  state,
  objectType,
  subjectId,
  width
}) {
  const [showLink, setShowLink] = useState(state !== 'Hidden');
  useEffect(() => {
    if (state === 'Hidden') {
      // Wait for transition to complete, then remove <a> element from the DOM.
      const timeout = setTimeout(() => setShowLink(false), 200);
      return () => clearTimeout(timeout);
    } else {
      setShowLink(true);
    }
  }, [state]);
  const MiniHighlight = useMemo(() => {
    switch (objectType) {
      case COMPANY:
        return MiniCompanyHighlight;
      case CONTACT:
        return MiniContactHighlight;
      case DEAL:
        return MiniDealHighlight;
      case TICKET:
        return MiniTicketHighlight;
      default:
        return MiniCrmObjectHighlight;
    }
  }, [objectType]);
  return /*#__PURE__*/_jsx(RecordsErrorBoundary, {
    boundaryName: "MiniProfileHighlightContainer",
    children: /*#__PURE__*/_jsx(MiniProfileHighlightWrapper, {
      state: state,
      width: width,
      "data-test-id": "mini-profile-highlight",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "600",
        padding: "400",
        blockSize: "100%",
        children: [showLink && /*#__PURE__*/_jsx(Box, {
          shrink: 0,
          children: /*#__PURE__*/_jsx(IndexOrPageReturnLink, {
            objectType: objectType
          })
        }), /*#__PURE__*/_jsx(MiniHighlight, {
          objectType: objectType,
          subjectId: subjectId
        })]
      })
    })
  });
}
MiniProfileHighlightContainer.propTypes = propTypes;
export default MiniProfileHighlightContainer;